import React, { useState } from "react";
import ReactModalWrap from "../../UI/Modals/ReactModalWrap/ReactModalWrap";
import ItemAvailabilityBadge from "../ItemAvailabilityBadge/ItemAvailabilityBadge";
import styles from "./ImageModal.module.scss";

interface ImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
  itemName: string;
  availabilityBadge?: {
    shortCode?: string;
    color?: string;
    needRP?: number;
    description?: string;
  };
}

export const ImageModal: React.FC<ImageModalProps> = ({
  isOpen,
  onClose,
  imageUrl,
  itemName,
  availabilityBadge,
}) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoading(false);
  };

  // Reset states when modal closes
  const handleClose = () => {
    setImageError(false);
    setImageLoading(true);
    onClose();
  };

  const customModalStyle = {
    content: {
      maxWidth: "90vw",
      maxHeight: "90vh",
      padding: "0",
      background: "transparent",
      border: "none",
    },
  };

  return (
    <ReactModalWrap
      isOpen={isOpen}
      close={handleClose}
      customStyle={customModalStyle}
    >
      <div className={styles.imageContainer}>
        {imageLoading && !imageError && (
          <div className={styles.loadingSpinner}>Loading...</div>
        )}

        {imageError ? (
          <div className={styles.errorMessage}>
            <p>Unable to load image</p>
            <p className={styles.errorSubtext}>{itemName}</p>
          </div>
        ) : (
          <>
            <img
              src={imageUrl}
              alt={itemName}
              className={styles.modalImage}
              onLoad={handleImageLoad}
              onError={handleImageError}
            />

            {availabilityBadge?.shortCode && (
              <div className={styles.badgeContainer}>
                <ItemAvailabilityBadge
                  shortCode={availabilityBadge.shortCode}
                  color={availabilityBadge.color}
                  needRP={availabilityBadge.needRP}
                  description={availabilityBadge.description}
                />
              </div>
            )}
          </>
        )}
      </div>
    </ReactModalWrap>
  );
};

export default ImageModal;
